import Auth from "Api/Auth";
import { Permissions, UserGroups } from "permissions/constants";

export const isAllowed = (operation) => {
  const permissionsArray = [UserGroups.SuperAdmin];
  const userGroup = Auth.decodedToken().group;
  switch (operation) {
    // startup checks
    case Permissions.EXPORT_STARTUP:
      return [
        ...permissionsArray,
        UserGroups.TopManagement,
        // UserGroups.Manager,
      ].includes(userGroup);

    case Permissions.DELETE_STARTUP:
      return [...permissionsArray].includes(userGroup);

    case Permissions.ADD_STARTUP:
      return [
        ...permissionsArray,
        UserGroups.TopManagement,
        UserGroups.Manager,
      ].includes(userGroup);

    case Permissions.UPDATE_STARTUP:
      return [
        ...permissionsArray,
        UserGroups.TopManagement,
        UserGroups.Manager,
      ].includes(userGroup);

    // investor checks
    case Permissions.EXPORT_INVESTOR:
      return [
        ...permissionsArray,
        UserGroups.TopManagement,
        // UserGroups.Manager,
      ].includes(userGroup);

    case Permissions.DELETE_INVESTOR:
      return [...permissionsArray].includes(userGroup);

    case Permissions.ADD_INVESTOR:
      return [
        ...permissionsArray,
        UserGroups.TopManagement,
        UserGroups.Manager,
      ].includes(userGroup);

    case Permissions.UPDATE_INVESTOR:
      return [
        ...permissionsArray,
        UserGroups.TopManagement,
        UserGroups.Manager,
      ].includes(userGroup);

    case Permissions.ALL_REPORT_OPTIONS:
      return [...permissionsArray, UserGroups.TopManagement].includes(
        userGroup
      );

    case Permissions.ALL_EMAIL_VISIBLE:
      return [...permissionsArray, UserGroups.TopManagement].includes(
        userGroup
      );

    default:
      return true;
  }
};
